import { handleProjectError } from "@/store/project/handle-project-error"
import {
	handleProjectFolderMissing,
	handleProjectPermissionMissing,
	OpenProjectOptions,
} from "./open-project"
import { ProjectOpenPreflightResult } from "./open-project-preflight"

export function handleProjectOpenPreflightResult(
	result: ProjectOpenPreflightResult,
	options: OpenProjectOptions,
) {
	if (result.ok) {
		return true
	}

	if (result.reason === "sample_mount_error") {
		void handleProjectError(result.error, {
			source: "project_open_preflight",
		})
		return false
	}

	if (result.reason === "no_permission" || result.reason === "no_access") {
		handleProjectPermissionMissing()
		return false
	}

	handleProjectFolderMissing(options)
	return false
}
